import Home from "../../../components/Home/Home";
import {sidebarItems} from "../../../utils/sidebarItems";

const SalesRepHome = () => {
    return (
       <Home navigationItems={sidebarItems.salesrep}/>
    )
}

export default SalesRepHome;